import { Grid, Popover } from '@material-ui/core';
import { Button, Icons, Typography } from '@nutrien/cxp-components';
import React from 'react';

import { useMst } from '../../mobx-models/Root';
import { DeficiencySortByFilter, DeficiencyView, Discipline } from '../../models/models';
import useStyles from './DeficienciesSortBy.styles';

interface Props {
  isSortByOpen: boolean;
  anchorEl: HTMLInputElement | null;
  handleClose: () => void;
  view: DeficiencyView;
  isActiveDeficiency: boolean;
  deficiencyFilters: DeficiencySortByFilter;
  handleFilterChange: (fieldName: keyof DeficiencySortByFilter) => void;
}

const ArrowUp = () => <Icons.ArrowUpFeather color="primary" />;
const ArrowDown = () => <Icons.ArrowDownFeather color="primary" />;

const DeficienciesSortBy: React.FC<Props> = ({
  isSortByOpen,
  anchorEl,
  handleClose,
  view,
  isActiveDeficiency,
  deficiencyFilters,
  handleFilterChange,
}) => {
  const classes = useStyles();
  const { SiteDiscipline } = useMst();
  const {
    name,
    componentType,
    conditionRating,
    remedialAction,
    urgency,
    areaId,
    actionType,
    status,
    removedFromPlanning,
    dateObserved,
    repairFactor,
  } = deficiencyFilters;
  const isShaft = SiteDiscipline.disciplineId === Discipline.Shaft;
  const isElectrical = SiteDiscipline.disciplineId === Discipline.Electrical;

  return (
    <Popover
      id="sortBy"
      open={isSortByOpen}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      classes={{ paper: classes.paper }}
    >
      <Grid className={classes.outerGridPopOver}>
        <Grid>
          {!isElectrical && (
            <>
              <Grid item xs={12} className={name !== '' ? classes.buttonBgPopOver : ''}>
                <Button
                  variant="text"
                  color="white"
                  noMinHeight
                  onClick={() => handleFilterChange('name')}
                  className="minWidthPopOver"
                >
                  <Typography
                    className={`${classes.commonTextPopOver} ${
                      name !== '' ? classes.selectedColorPopOver : classes.deSelectedColorPopOver
                    }`}
                  >
                    Component Name
                  </Typography>
                  <Typography className={classes.popoverArrow}>
                    {name === 'asc' && <ArrowUp />}
                    {name === 'desc' && <ArrowDown />}
                  </Typography>
                </Button>
              </Grid>
              <Grid item xs={12} className={componentType !== '' ? classes.buttonBgPopOver : ''}>
                <Button
                  variant="text"
                  color="white"
                  noMinHeight
                  className="minWidthPopOver"
                  onClick={() => handleFilterChange('componentType')}
                >
                  <Typography
                    className={`${classes.commonTextPopOver} ${
                      componentType !== ''
                        ? classes.selectedColorPopOver
                        : classes.deSelectedColorPopOver
                    }`}
                  >
                    Component Type
                  </Typography>
                  <Typography className={classes.popoverArrow}>
                    {componentType === 'asc' && <ArrowUp />}
                    {componentType === 'desc' && <ArrowDown />}
                  </Typography>
                </Button>
              </Grid>
              {view.card && (
                <Grid
                  item
                  xs={12}
                  className={conditionRating !== '' ? classes.buttonBgPopOver : ''}
                >
                  <Button
                    variant="text"
                    color="white"
                    noMinHeight
                    className="minWidthPopOver"
                    onClick={() => handleFilterChange('conditionRating')}
                  >
                    <Typography
                      className={`${classes.commonTextPopOver} ${
                        conditionRating !== ''
                          ? classes.selectedColorPopOver
                          : classes.deSelectedColorPopOver
                      }`}
                    >
                      Condition Rating
                    </Typography>
                    <Typography className={classes.popoverArrow}>
                      {conditionRating === 'asc' && <ArrowUp />}
                      {conditionRating === 'desc' && <ArrowDown />}
                    </Typography>
                  </Button>
                </Grid>
              )}
              {!isShaft && (
                <Grid item xs={12} className={areaId !== '' ? classes.buttonBgPopOver : ''}>
                  <Button
                    variant="text"
                    color="white"
                    noMinHeight
                    className="minWidthPopOver"
                    onClick={() => handleFilterChange('areaId')}
                  >
                    <Typography
                      className={`${classes.commonTextPopOver} ${
                        areaId !== ''
                          ? classes.selectedColorPopOver
                          : classes.deSelectedColorPopOver
                      }`}
                    >
                      Primary Area
                    </Typography>
                    <Typography className={classes.popoverArrow}>
                      {areaId === 'asc' && <ArrowUp />}
                      {areaId === 'desc' && <ArrowDown />}
                    </Typography>
                  </Button>
                </Grid>
              )}
              <Grid item xs={12} className={remedialAction !== '' ? classes.buttonBgPopOver : ''}>
                <Button
                  variant="text"
                  color="white"
                  noMinHeight
                  className="minWidthPopOver"
                  onClick={() => handleFilterChange('remedialAction')}
                >
                  <Typography
                    className={`${classes.commonTextPopOver} ${
                      remedialAction !== ''
                        ? classes.selectedColorPopOver
                        : classes.deSelectedColorPopOver
                    }`}
                  >
                    Remedial Action
                  </Typography>
                  <Typography className={classes.popoverArrow}>
                    {remedialAction === 'asc' && <ArrowUp />}
                    {remedialAction === 'desc' && <ArrowDown />}
                  </Typography>
                </Button>
              </Grid>
              <Grid item xs={12} className={urgency !== '' ? classes.buttonBgPopOver : ''}>
                <Button
                  variant="text"
                  color="white"
                  noMinHeight
                  className="minWidthPopOver"
                  onClick={() => handleFilterChange('urgency')}
                >
                  <Typography
                    className={`${classes.commonTextPopOver} ${
                      urgency !== '' ? classes.selectedColorPopOver : classes.deSelectedColorPopOver
                    }`}
                  >
                    Urgency
                  </Typography>
                  <Typography className={classes.popoverArrow}>
                    {urgency === 'asc' && <ArrowUp />}
                    {urgency === 'desc' && <ArrowDown />}
                  </Typography>
                </Button>
              </Grid>
            </>
          )}
          {isElectrical && (
            <>
              <Grid item xs={12} className={dateObserved !== '' ? classes.buttonBgPopOver : ''}>
                <Button
                  variant="text"
                  color="white"
                  noMinHeight
                  className="minWidthPopOver"
                  onClick={() => handleFilterChange('dateObserved')}
                >
                  <Typography
                    className={`${classes.commonTextPopOver} ${
                      dateObserved !== ''
                        ? classes.selectedColorPopOver
                        : classes.deSelectedColorPopOver
                    }`}
                  >
                    Date Observed
                  </Typography>
                  <Typography className={classes.popoverArrow}>
                    {dateObserved === 'asc' && <ArrowUp />}
                    {dateObserved === 'desc' && <ArrowDown />}
                  </Typography>
                </Button>
              </Grid>
              <Grid item xs={12} className={remedialAction !== '' ? classes.buttonBgPopOver : ''}>
                <Button
                  variant="text"
                  color="white"
                  noMinHeight
                  className="minWidthPopOver"
                  onClick={() => handleFilterChange('remedialAction')}
                >
                  <Typography
                    className={`${classes.commonTextPopOver} ${
                      remedialAction !== ''
                        ? classes.selectedColorPopOver
                        : classes.deSelectedColorPopOver
                    }`}
                  >
                    Remedial Action
                  </Typography>
                  <Typography className={classes.popoverArrow}>
                    {remedialAction === 'asc' && <ArrowUp />}
                    {remedialAction === 'desc' && <ArrowDown />}
                  </Typography>
                </Button>
              </Grid>
              <Grid item xs={12} className={repairFactor !== '' ? classes.buttonBgPopOver : ''}>
                <Button
                  variant="text"
                  color="white"
                  noMinHeight
                  className="minWidthPopOver"
                  onClick={() => handleFilterChange('repairFactor')}
                >
                  <Typography
                    className={`${classes.commonTextPopOver} ${
                      repairFactor !== ''
                        ? classes.selectedColorPopOver
                        : classes.deSelectedColorPopOver
                    }`}
                  >
                    Repair Factor
                  </Typography>
                  <Typography className={classes.popoverArrow}>
                    {repairFactor === 'asc' && <ArrowUp />}
                    {repairFactor === 'desc' && <ArrowDown />}
                  </Typography>
                </Button>
              </Grid>
            </>
          )}
          {isActiveDeficiency && (
            <>
              <Grid item xs={12} className={actionType !== '' ? classes.buttonBgPopOver : ''}>
                <Button
                  variant="text"
                  color="white"
                  noMinHeight
                  className="minWidthPopOver"
                  onClick={() => handleFilterChange('actionType')}
                >
                  <Typography
                    className={`${classes.commonTextPopOver} ${
                      actionType !== ''
                        ? classes.selectedColorPopOver
                        : classes.deSelectedColorPopOver
                    }`}
                  >
                    Action Type
                  </Typography>
                  <Typography className={classes.popoverArrow}>
                    {actionType === 'asc' && <ArrowUp />}
                    {actionType === 'desc' && <ArrowDown />}
                  </Typography>
                </Button>
              </Grid>
              <Grid item xs={12} className={status !== '' ? classes.buttonBgPopOver : ''}>
                <Button
                  variant="text"
                  color="white"
                  noMinHeight
                  className="minWidthPopOver"
                  onClick={() => handleFilterChange('status')}
                >
                  <Typography
                    className={`${classes.commonTextPopOver} ${
                      status !== '' ? classes.selectedColorPopOver : classes.deSelectedColorPopOver
                    }`}
                  >
                    Status
                  </Typography>
                  <Typography className={classes.popoverArrow}>
                    {status === 'asc' && <ArrowUp />}
                    {status === 'desc' && <ArrowDown />}
                  </Typography>
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                className={removedFromPlanning !== '' ? classes.buttonBgPopOver : ''}
              >
                <Button
                  variant="text"
                  color="white"
                  noMinHeight
                  className="minWidthPopOver"
                  onClick={() => handleFilterChange('removedFromPlanning')}
                >
                  <Typography
                    className={`${classes.commonTextPopOver} ${
                      removedFromPlanning !== ''
                        ? classes.selectedColorPopOver
                        : classes.deSelectedColorPopOver
                    }`}
                  >
                    Removed from Planning
                  </Typography>
                  <Typography className={classes.popoverArrow}>
                    {removedFromPlanning === 'asc' && <ArrowUp />}
                    {removedFromPlanning === 'desc' && <ArrowDown />}
                  </Typography>
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Popover>
  );
};

export default DeficienciesSortBy;
